import React from 'react';
import { Field, Pill, inputCls, slug } from './atoms';
import { TIMELINES, LIFESTYLE, MX_DESTINATIONS } from './constants';

const Step3Destination = ({ form, errors, upd, setField, toggleLifestyle }) => (
  <div data-testid="step-3">
    <div className="mb-5">
      <h1 className="text-xl sm:text-2xl font-light" data-testid="step3-headline">
        Where in Mexico?
      </h1>
      <p className="text-sm mt-1 text-[#5A6B73]">Got a city in mind, or still exploring?</p>
    </div>

    <div className="space-y-4">
      <Field label="Do you have a destination in mind?" error={errors.destination_decided} testId="field-destination-decided">
        <div className="grid grid-cols-2 gap-2">
          <Pill active={form.destination_decided === true}
            onClick={() => setField('destination_decided', true)}
            testId="onboarding-decided-yes">Yes</Pill>
          <Pill active={form.destination_decided === false}
            onClick={() => setField('destination_decided', false)}
            testId="onboarding-decided-no">Not sure yet</Pill>
        </div>
      </Field>

      {form.destination_decided === true && (
        <Field label="Which city, state, or region?" error={errors.destination_city} testId="field-destination-city">
          <input type="text" list="mx-destinations" value={form.destination_city}
            onChange={upd('destination_city')}
            placeholder="Type any city in Mexico…"
            className={inputCls(errors.destination_city)}
            data-testid="onboarding-destination-input" />
          <datalist id="mx-destinations">
            {MX_DESTINATIONS.map((d) => <option key={d} value={d} />)}
          </datalist>
        </Field>
      )}

      {form.destination_decided === false && (
        <Field label="What kind of place attracts you? (pick any)" error={errors.lifestyle_preferences} testId="field-lifestyle">
          <div className="grid grid-cols-2 gap-2">
            {LIFESTYLE.map((p) => (
              <Pill key={p} active={form.lifestyle_preferences.includes(p)}
                onClick={() => toggleLifestyle(p)}
                testId={`onboarding-lifestyle-${slug(p)}`}>
                {p}
              </Pill>
            ))}
          </div>
        </Field>
      )}

      <Field label="When are you planning to move?" error={errors.move_timeline} testId="field-timeline">
        <div className="grid grid-cols-2 gap-2">
          {TIMELINES.map((t) => (
            <Pill key={t} active={form.move_timeline === t}
              onClick={() => setField('move_timeline', t)}
              testId={`onboarding-timeline-${slug(t)}`}>
              {t}
            </Pill>
          ))}
        </div>
      </Field>
    </div>
  </div>
);

export default Step3Destination;
